import React from 'react';
import { GOOGLE_API_CLIENT_ID, GOOGLE_REDIRECT_URI } from '../../../../constants/url';

import googleImg from '../../../../images/common/btn_google.svg';

const GoogleLogin = () => {

    return (
        <button data-login="google" title="구글 아이디로 로그인 하기" onClick={() => {
            const redirectUri = encodeURIComponent(GOOGLE_REDIRECT_URI);
            const scope = encodeURIComponent('openid email');
            window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_API_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`;
        }}>
            <img src={googleImg} alt="구글 로그인" />
        </button>
    );
};

export default GoogleLogin;
